import { createAsyncActionType } from './index';

export const CONFIG_TEXT_GET = createAsyncActionType(
  'configuration',
  'CONFIG_TEXT_GET'
);
